<template>
  <div class="right-chart-wrap">
    <targets />
    <div class="row right-bottom-chart w-100 m-0 mb-4">
      <div class="row w-100 m-0">
        <div class="chart-title-2 w-100">
          <div class="col-lg-11 col-xl-6 m-0 p-0">
            <h6 class="mr-0 mr-lg-3 position-relative">
              <span class="clickable" @click="openNews()">
                {{ $t('dashboard.titles.news') }}
              </span>
              <span class="title-question-icon" @click.prevent="toggleHelp()">
                <iquestion />
              </span>
              <header-selector
                :options="headerOptions"
                :selected="mode"
                @change="
                  (to) => {
                    changeMode(to)
                  }
                "
              />
            </h6>
          </div>
          <div class="col-lg-1 col-xl-6 m-0 p-0 d-none d-lg-block">
            <h6>
              <div class="float-right pulse-blue">
                <iopenfull class="svg-hover" @click.native="openNews()" />
              </div>
            </h6>
          </div>
        </div>
      </div>
      <!-- End of header-->
      <div class="row w-100 m-0">
        <div class="col-lg-6 px-0 pl-lg-0">
          <news
            :news="news[mode]"
            @newsclick="
              (news) => {
                openNews(news)
              }
            "
          />
        </div>
        <div class="col-lg-6 px-0 pr-lg-0">
          <div
            class="switchs-graph h-100 position-relative"
            style="min-height: 50px;"
            :class="{
              'no-content': noContentGraph,
            }"
          >
            <div class="graph">
              <p v-if="noContentGraph">
                {{ $t('dashboard.news.noContentGraph') }}
              </p>
              <news-graph v-else :chartData="statistics[mode]" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row right-mid-chart">
      <div class="col-lg-6">
        <dividents />
      </div>
      <div class="col-lg-6">
        <multipliers />
      </div>
    </div>
    <invest-ideas />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import _ from 'lodash'
import Targets from './Targets'
import InvestIdeas from './InvestIdeas'
import Dividents from './Dividents'
import Multipliers from './Multipliers'
import News from './News'
import NewsGraph from './NewsGraph'
import HeaderSelector from './HeaderSelector'
import iquestion from '@/components/icons/question'
import iopenfull from '@/components/icons/openfull'

export default {
  data() {
    return {
      mode: 'picked',
    }
  },
  computed: {
    ...mapState('news', ['news', 'search', 'statistics', 'average']),
    headerOptions() {
      return [
        {
          name: 'picked',
          text: this.$t('dashboard.news.selector.picked'),
        },
        {
          name: 'magazines',
          text: this.$t('dashboard.news.selector.magazines'),
        },
        {
          name: 'socials',
          text: this.$t('dashboard.news.selector.socials'),
        },
      ]
    },
    noContentGraph() {
      return !(
        _.isArray(this.statistics[this.mode]) &&
        this.statistics[this.mode].length > 1
      )
    },
  },
  methods: {
    toggleHelp() {
      this.$store.commit('layout/updateModal', {
        modal: 'help',
        show: true,
        title:
          this.mode === 'magazines'
            ? this.$t('modals.references.magazines.title')
            : this.$t('modals.references.socials.title'),
        content:
          this.mode === 'magazines'
            ? this.$t('modals.references.magazines.content')
            : this.$t('modals.references.socials.content'),
        subtitle: this.$t('modals.messages.reference'),
      })
    },
    openNews({ id: PostId, db: dbName }) {
      this.$router.push({
        path: this.$route.path,
        query: {
          m: 'news',
          cat: dbName || this.mode,
          ...(PostId && { pid: PostId }),
        },
      })
    },
    changeMode(mode) {
      this.mode = mode
    },
  },
  watch: {
    news(newVal) {
      // if no picked news, get magazines, otherwise get socials
      if (newVal.picked && newVal.picked.length > 0)
        return (this.mode = 'picked')
      if (newVal.magazines && newVal.magazines.length > 0)
        return (this.mode = 'magazines')
      this.mode = 'socials'
    },
  },
  components: {
    targets: Targets,
    'invest-ideas': InvestIdeas,
    dividents: Dividents,
    multipliers: Multipliers,
    news: News,
    iquestion: iquestion,
    iopenfull: iopenfull,
    'news-graph': NewsGraph,
    'header-selector': HeaderSelector,
  },
}
</script>

<style lang="scss">
.Custom_Scrollbar {
  @include scrollbars(8px, rgba(#c2c2d6, 0.4), rgba(#c2c2d6, 0.2));
  @include transition();
  &:hover {
    @include scrollbars(8px, rgba(#c2c2d6, 1), rgba(#c2c2d6, 0.2));
  }
}
.no-content p {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  font-weight: 300;
  font-size: 1rem;
  text-align: center;
}

.custom-border,
.no-content {
  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    $border-color: #c2c2c2;
    $gap-size: 10px;
    $dash-size: 16px;
    $border-weight: 1px;

    background: linear-gradient(90deg, $border-color 100%, transparent 100%) top
        left no-repeat,
      linear-gradient(
          90deg,
          transparent $gap-size / 2,
          $border-color $gap-size / 2,
          $border-color $gap-size / 2 + $dash-size,
          transparent $gap-size / 2 + $dash-size
        )
        top center repeat-x,
      linear-gradient(90deg, $border-color 100%, transparent 100%) top right
        no-repeat,
      linear-gradient(0deg, $border-color 100%, transparent 100%) top left
        no-repeat,
      linear-gradient(
          0deg,
          transparent $gap-size / 2,
          $border-color $gap-size / 2,
          $border-color $gap-size / 2 + $dash-size,
          transparent $gap-size / 2 + $dash-size
        )
        center left repeat-y,
      linear-gradient(0deg, $border-color 100%, transparent 100%) bottom left
        no-repeat,
      linear-gradient(90deg, $border-color 100%, transparent 100%) bottom left
        no-repeat,
      linear-gradient(
          90deg,
          transparent $gap-size / 2,
          $border-color $gap-size / 2,
          $border-color $gap-size / 2 + $dash-size,
          transparent $gap-size / 2 + $dash-size
        )
        bottom center repeat-x,
      linear-gradient(90deg, $border-color 100%, transparent 100%) bottom right
        no-repeat,
      linear-gradient(0deg, $border-color 100%, transparent 100%) top right
        no-repeat,
      linear-gradient(
          0deg,
          transparent $gap-size / 2,
          $border-color $gap-size / 2,
          $border-color $gap-size / 2 + $dash-size,
          transparent $gap-size / 2 + $dash-size
        )
        center right repeat-y,
      linear-gradient(0deg, $border-color 100%, transparent 100%) bottom right
        no-repeat;
    background-size: $dash-size $border-weight,
      $dash-size + $gap-size $border-weight, $dash-size $border-weight,
      $border-weight $dash-size, $border-weight $dash-size + $gap-size,
      $border-weight $dash-size;
  }
}

.right-mid-chart {
  .right-top-chart-table {
    height: 184px;
    overflow-y: auto;
    @extend .Custom_Scrollbar;
    overflow-x: hidden;

    &:hover {
      overflow-x: auto;
    }
  }

  .right-mid-chart-right {
    .chart-cover {
      padding-bottom: 55px;
    }

    .nav-tabs {
      border: none;
      display: flex;

      .nav-item {
        display: inline-block;
        padding-right: 5px;
        padding-left: 5px;
        margin: 0;
        border-bottom: 2px solid #d1d1de;

        &:first-child {
          padding-left: 0;
        }
        &:last-child {
          padding-right: 0;
          .nav-link {
            margin-right: 0;
          }
        }
      }

      .nav-link {
        color: #1c1b20;
        font-weight: 400;
        font-size: 1rem;
        text-transform: uppercase;
        border: none;
        padding: 0;
        position: relative;
        background: transparent;

        &.active {
          color: $primary-color2;
          ~ {
            border-bottom-color: $primary-color2;
          }

          &:after {
            opacity: 1;
            visibility: visible;
            width: 100%;
          }
        }
        &.main {
          font-weight: 700;
        }

        &:after {
          position: absolute;
          left: 0;
          bottom: -2px;
          height: 2px;
          width: 0;
          content: '';
          background: $primary-color2;
          opacity: 0;
          visibility: hidden;
          @include transition();
        }

        &:hover {
          color: $primary-color2;
          cursor: pointer;
        }
      }
    }

    .tab-content {
      margin-top: 80px;

      .bars-panel {
        position: relative;
        height: 20px;
        background: #ddd;
        background: linear-gradient(
          90deg,
          #33c96f 0%,
          #ffbe40 51.75%,
          #ff0100 100%
        );

        &.with-grey {
          background: linear-gradient(
            90deg,
            #ccc 0%,
            #ccc 14.9%,
            #33c96f 15%,
            #ffbe40 51.75%,
            #ff0100 100%
          );
        }

        .single-bars-item {
          display: inline-block;
          position: absolute;
          top: -24px;
          left: 10%;
          cursor: pointer;

          & > * {
            transform: translateX(-50%);
          }

          &.bars-item2 {
            left: 30%;
          }

          &.bars-item3 {
            left: 55%;

            &:hover {
              .popover__content {
                left: -70px;
              }
            }
          }

          &.text-bar-big {
            left: 35%;
            top: -50px;

            h5 {
              font-size: 1rem;
              position: relative;
              margin-bottom: 10px;
              z-index: 5;
              background-color: white;
              width: 130%;
              text-align: center;

              // &:after {
              //   position: absolute;
              //   left: 50%;
              //   top: 25px;
              //   height: 25px;
              //   width: 3px;
              //   content: '';
              //   background: #e9bf45;
              //   margin-left: -1px;
              // }
            }
          }

          &.text-bar {
            bottom: -47px;
            left: 30%;
            top: auto;

            &.text-bar2 {
              left: 60%;
              bottom: -62px;

              p {
                padding-top: 40px;
                white-space: nowrap;
                // &:after {
                //   position: absolute;
                //   left: 50%;
                //   top: 0;
                //   height: 15px;
                //   width: 2px;
                //   content: '';
                //   background: #ff591e;
                //   margin-left: -1px;
                // }
              }
            }

            p {
              font-size: 0.75rem;
              color: $text-color;
              position: relative;
              margin-bottom: 0;
              padding-top: 25px;
              white-space: nowrap;

              // &:after {
              //   position: absolute;
              //   left: 50%;
              //   top: 0;
              //   height: 15px;
              //   width: 2px;
              //   content: '';
              //   background: #ccc14c;
              //   margin-left: -1px;
              // }
            }
          }

          .tooltip-trigger {
            margin-bottom: 0.6em;
            font-size: 0.75rem;
            color: $title-color;
            position: relative;
            text-align: center;

            @media (max-width: 550px) {
              margin-bottom: 1.2em;
            }

            // &:after {
            //   position: absolute;
            //   left: 50%;
            //   bottom: -2px;
            //   height: 6px;
            //   width: 2px;
            //   content: '';
            //   background: #b6c251;
            //   margin-left: -1px;
            // }

            // &.trigger-1:after {
            //   background: #6dc662;
            // }
            // &.trigger-2:after {
            //   background: #b6c251;
            // }
            // &.trigger-3:after {
            //   background: #ffac3a;
            // }
          }

          h6 {
            font-size: 0.75rem;
            font-weight: 400;
          }

          .popover__content {
            opacity: 0;
            visibility: hidden;
            position: absolute;
            background: #fff;
            padding: 12px;
            left: 100%;
            top: 50%;
            // @include transition();
            box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1),
              0px 4px 16px rgba(0, 0, 0, 0.16);
            border-radius: 4px;
            width: 244px;
            z-index: 2;

            p {
              font-size: 0.75rem;
              line-height: 1.125rem;
              margin-bottom: 0;
              color: $title-color;
            }
          }

          &:hover {
            .popover__content {
              opacity: 1;
              visibility: visible;
              left: 107%;
              z-index: 999;
            }
          }
        }
      }
    }
  }
}

.text__hide {
  font-size: 1rem;
  line-height: 1.5rem;
}
@media (max-width: 1199px) {
  .text__hide {
    display: none;
  }
}
@media (max-width: 991px) {
  .text__hide {
    display: inline-block;
  }
}
.chart-title-2 {
  .primary-text {
    display: none;
    .text__hide {
      color: $primary-color2;
    }
  }
  .secendary-text {
    display: inline-block;
  }

  &:hover {
    .primary-text {
      display: inline-block;
    }
    .secendary-text {
      display: none;
    }
  }
}
.right-search-chart {
  height: 100%;
  @media (max-width: 990px) {
    margin-bottom: 30px;
    height: calc(100% - 30px);
  }
}

.clickable:hover {
  cursor: pointer;
}

@keyframes pulse-blue {
  0% {
    // transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 166, 203, 0.5);
  }

  70% {
    // transform: scale(0.85);
    box-shadow: 0 0 0 20px rgba(0, 166, 203, 0);
  }

  100% {
    // transform: scale(1);
    box-shadow: 0 0 0 0 rgba(0, 166, 203, 0);
  }
}
.pulse-blue {
  border-radius: 50%;
  animation: pulse-blue 2s infinite;
}
</style>
